import React from "react";
import CrudTable from "../components/CrudTable";
import { StatusBadge } from "../components/common";

const columns = [
  { key: "name", label: "Brand" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  { key: "gst_number", label: "GST" },
  { key: "city", label: "City" },
  { key: "status", label: "Status", status: true },
];
const formFields = [
  { name: "name", label: "Company Name", required: true },
  { name: "email", label: "Email", required: true, type: "email" },
  { name: "phone", label: "Phone", required: true },
  { name: "gst_number", label: "GST Number" },
  { name: "pan", label: "PAN" },
  { name: "primary_contact", label: "Primary Contact" },
  { name: "city", label: "City", required: true },
  { name: "state", label: "State" },
  { name: "address", label: "Address", wide: true },
  { name: "pincode", label: "Pincode" },
  { name: "status", label: "Status", type: "select", default: "pending",
    options: [{ value: "pending", label: "Pending" }, { value: "active", label: "Active" }, { value: "suspended", label: "Suspended" }] },
];

export default function Brands() {
  return <CrudTable
    title="Brands"
    description="Onboard, review and manage all customer brands using RushGro PBaaS."
    endpoint="/brands"
    columns={columns}
    formFields={formFields}
  />;
}
